import React from 'react'
import giphy from '../../images/loading.gif'

export default function Loading() {
  return (
    <img src={giphy} />
  )
}
